import {
  EditUserPermissionsTableRow,
  UserPermissionsCriteria,
  UserSalesOrderPermissionTableRow,
} from '@zspace/types';

export function filterUserPermissions(
  userPermissions:
    | EditUserPermissionsTableRow[]
    | UserSalesOrderPermissionTableRow[],
  criteria: UserPermissionsCriteria
) {
  return userPermissions.filter((permission) => {
    if (
      criteria.opportunities?.length &&
      !criteria.opportunities.some((opportunity) => {
        return (
          permission.opportunity?.name.toLowerCase() ===
          opportunity.toLowerCase()
        );
      })
    ) {
      return false;
    }

    if (
      criteria.salesOrders?.length &&
      !criteria.salesOrders.some((number) => {
        const criteriaSearchNumberValue = number.replace(/\D/g, '');
        return permission.number === Number(criteriaSearchNumberValue);
      })
    ) {
      return false;
    }

    return true;
  });
}
